export const CASE_CANCELLATION_ROLE_TYPES = Object.freeze([
  'administrator',
  'production_responsible',
  'logistics_coordinator',
  'agent_administratif',
]);

const CANCELLATION_ROLES = new Set(CASE_CANCELLATION_ROLE_TYPES);
const TERMINAL_CASE_STATUSES = new Set(['completed', 'cancelled', 'archived']);
const STARTED_PHASE_STATUSES = new Set(['in_progress', 'submitted', 'completed']);

const normalizeRoles = (userRole, userRoleTypes = []) => [
  ...new Set(
    [userRole, ...(Array.isArray(userRoleTypes) ? userRoleTypes : [])]
      .filter(Boolean)
      .map(String)
  ),
];

export function hasCaseCancellationRole(userRole, userRoleTypes = []) {
  return normalizeRoles(userRole, userRoleTypes).some((role) => CANCELLATION_ROLES.has(role));
}

export function hasCasePrintingStarted(phases = []) {
  return (phases || []).some((phase) => {
    const group = Number.parseInt(String(phase?.group ?? ''), 10);
    const order = Number(phase?.phase_order);
    const status = String(phase?.status || '');

    if (group === 1 && order >= 5) return STARTED_PHASE_STATUSES.has(status);
    if (group >= 2) return status !== 'pending';
    return false;
  });
}

export function canCancelCaseOrder({
  userRole,
  userRoleTypes = [],
  caseStatus,
  phases = [],
}) {
  if (!hasCaseCancellationRole(userRole, userRoleTypes)) return false;
  if (TERMINAL_CASE_STATUSES.has(String(caseStatus || ''))) return false;
  return !hasCasePrintingStarted(phases);
}

async function runLifecycleRpc(supabase, functionName, params) {
  const { data, error } = await supabase.rpc(functionName, params);
  if (error) throw error;
  return data || { ok: false, error: 'empty_response' };
}

export function completeCaseShippingPhase(supabase, phaseId) {
  return runLifecycleRpc(supabase, 'complete_case_shipping_phase', {
    p_phase_id: phaseId,
  });
}

export function cancelCaseOrder(supabase, caseId, reason = null) {
  return runLifecycleRpc(supabase, 'cancel_case_order', {
    p_case_id: caseId,
    p_reason: reason,
  });
}

export function commandCaseFollowUp(supabase, caseId) {
  return runLifecycleRpc(supabase, 'command_case_follow_up', {
    p_case_id: caseId,
  });
}

export const CASE_CANCELLATION_ERROR_MESSAGES = Object.freeze({
  not_authenticated: 'Vous devez être connecté.',
  forbidden: 'Vous n’avez pas le droit d’annuler cette commande.',
  case_not_found: 'Commande introuvable.',
  already_cancelled: 'Cette commande a déjà été annulée par un autre utilisateur.',
  case_status_blocks_cancellation: 'Cette commande ne peut plus être annulée.',
  printing_already_started: 'Impossible d’annuler : l’impression 3D a démarré.',
  empty_response: 'L’annulation a échoué. Réessayez.',
});

export function getCaseCancellationErrorMessage(code) {
  return CASE_CANCELLATION_ERROR_MESSAGES[code] || 'L’annulation a échoué. Réessayez.';
}
